import axios from '..';

export const fetchCurriculumByOrgUnitInstanceId = unitID =>
  axios.get(`/api/class/${unitID}/curriculum-student`);
